<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Overview', icon: 'tachometer-alt text-default', path: '/dashboard' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'Organisations', icon: 'sitemap text-default', path: '/organisations' }"
        ></sidebar-item>
        <sidebar-item :link="{ name: 'Farms', icon: 'warehouse text-default', path: '/farms' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Orchards', icon: 'tree text-default', path: '/groups' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Traps', icon: 'map-marker-alt text-default', path: '/sensors' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Users', icon: 'users text-default', path: '/users' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Roles', icon: 'shield-alt text-default', path: '/access/roles' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Reports', icon: 'clipboard-list text-default', path: '/reports' }"></sidebar-item>
        <!-- <sidebar-item :link="{ name: 'System', icon: 'tools text-default', path: '/system/settings' }"></sidebar-item> -->
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div>
        <router-view @onApiResult="handleApiResult" @loading="handleLoading"></router-view>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>

//  @click="$sidebar.displaySidebar(false)"
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import { Notification, Loading } from 'element-ui';


function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent
  },
  data() {
    return {
      loadingInstance: null
    }
  },
  methods: {
    handleLoading: function(isLoading) {
      if(isLoading) {
        this.loadingInstance = Loading.service({ 
          fullscreen: true,
          lock: true,
          background: 'rgba(255, 255, 255, 0.8)!important' 
        });
      }
      else {
        this.loadingInstance.close();
      }
    },
    handleApiResult(message) {
      this.$notify({
        title: 'Success',
        message: message,
        type: 'success',
        duration: 2500
      });
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    }
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>
